import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

/** true somente quando a sessão já foi verificada e não há ninguém logado. */
export function useIsVisitor() {
  const [state, setState] = useState({ ready: false, visitor: false });

  useEffect(() => {
    let active = true;
    const check = (session) => {
      if (active) setState({ ready: true, visitor: !session?.user });
    };
    supabase.auth.getSession().then(({ data }) => check(data.session));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => check(session));
    return () => {
      active = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  return state.ready && state.visitor;
}

/** Mostra o conteúdo apenas para visitantes sem login. */
export function VisitorOnly({ children }) {
  return useIsVisitor() ? children : null;
}